import { AuthService } from '../services/auth.service';

export const displayUsername = (
    username: string | null | undefined,
    institutionCode?: string | null,
): string => {
    if (!username) return '';
    const code = institutionCode ?? AuthService.getSelectedInstitutionCode();
    if (code) {
        const prefix = `${code}_`;
        if (username.startsWith(prefix)) {
            return username.slice(prefix.length);
        }
    }
    return username;
};

/**
 * Person-facing name: the profile's full name when there is one, otherwise the username (without
 * the institution prefix). A backend "display name" that merely echoes the raw username (no
 * profile name) counts as absent so the prefix is still stripped.
 */
export const displayPersonName = (
    fullName: string | null | undefined,
    username: string | null | undefined,
    institutionCode?: string | null,
): string => {
    const name = fullName?.trim();
    if (name && name !== username) return name;
    return displayUsername(username, institutionCode);
};

/** Leave reasons written by the demo simulator carry a trailing " [simNNNN]" tag — hide it on display. */
export const cleanLeaveReason = (reason: string | null | undefined): string =>
    (reason ?? '').replace(/\s*\[sim\d+\]\s*$/, '');
